import { render } from "./JsonView.vue?vue&type=template&id=3aaa1882&scoped=true"
import script from "./JsonView.vue?vue&type=script&lang=js"
export * from "./JsonView.vue?vue&type=script&lang=js"

import "./JsonView.vue?vue&type=style&index=0&id=3aaa1882&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaa1882"]])

export default __exports__